import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AccordionItem as Item } from '@szhsin/react-accordion';

type AccordionItemProps = {
  header: string
  chevronPosition?: 'before' | 'after'
  lastItem?: boolean
  children: any
}

const AccordionItem: React.FC<AccordionItemProps> = ({ header, chevronPosition = 'after', lastItem = false, ...rest }) => (
  <Item
    {...rest}
    header={
      <>
        {chevronPosition === 'before' && <FontAwesomeIcon icon={faChevronDown} className='chevron before' />}
        <p className='accordion--header'>{header}</p>
        {chevronPosition === 'after' && <FontAwesomeIcon icon={faChevronDown} className='chevron' />}
      </>
    }
    className={`item ${chevronPosition} ${lastItem ? 'last' : ''}`}
    buttonProps={{
      className: ({ isEnter }) =>
        `item-btn ${chevronPosition === 'before' ? 'before' : ''} ${isEnter && 'item-btn-expanded'}`,
    }}
    contentProps={{ className: `item-content ${chevronPosition === 'before' ? 'before' : ''}` }}
    panelProps={{ className: 'item-panel' }}
  />
);

export default AccordionItem